module.exports = __webpack_public_path__ + "media/images/main/k8-3c13a6d902357ce83f5c776a4044855b.jpg";